export default __webpack_public_path__ + "static/media/cardActivationhelpMobileHighlight@2x.847b5736.png";